import React from 'react'
import DetailsPage from './Tabs/DetailsPage';
import { Link } from 'react-router-dom';

export default function RetailerOrderDetails() {
  const order = {
    orderID: "1234567",
  };
  return (
    <div className="content-body">
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12 col-lg-12">
            <div className="card">
              <div className="card-header card-header2">
                <h4 className="card-title--medium card-title2">Retailer Order Details</h4>
      
                <div className='d-flex'>
                <h5 className="order-id card-title--medium card-title2 back-head ">
                  Order ID: {order.orderID}
                </h5>
                  <Link to="/retailer/orders">
                    <img src="/assets/images/kidskart/icon/back-button.png" />
                  </Link>{" "}
                </div>
              </div>
              <div className="content">
                <DetailsPage />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
